/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Sales_Debtor_TotalInputs */

const vi_dashboard_sales_debtor_total = /** @type {(inputs: Dashboard_Sales_Debtor_TotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tổng nợ`)
};

/**

* @param {Dashboard_Sales_Debtor_TotalInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const dashboard_sales_debtor_total = /** @type {((inputs?: Dashboard_Sales_Debtor_TotalInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Sales_Debtor_TotalInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_dashboard_sales_debtor_total(inputs)
});